export const isActiveRoute = (path: string, pathname: string, lang: string) => {
  const normalizedPath = path.replace(/\/$/, '');
  const normalizedPathname = pathname.replace(/\/$/, '');

  if (path === '/' || path === `/${lang}`) {
    return {
      active:
        pathname === '/' ||
        pathname === '/en' ||
        pathname === '/en/' ||
        pathname === `/${lang}` ||
        pathname === `/${lang}/`,
      clickable: false,
    };
  }

  if (normalizedPath === normalizedPathname) return { active: true, clickable: false };

  if (normalizedPathname.startsWith(normalizedPath)) {
    if (path.includes('games') && pathname.split('/').length === path.split('/').length + 1)
      return { active: true, clickable: false };

    return { active: true, clickable: true };
  }
};

export const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const DEFAULT_LANGUAGE = 'en';

// Language the user picked in the language switcher; the home page opens in it on later visits
export const PREFERRED_LANGUAGE_COOKIE = 'preferred_locale';

export const savePreferredLanguage = (lang: string) => {
  document.cookie = `${PREFERRED_LANGUAGE_COOKIE}=${lang}; path=/; max-age=31536000; samesite=lax`;
};